import AuctionReport from "./AuctionReport";

export default AuctionReport;
